import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import LinkedIn from './svg/linkedin'
import Facebook from './svg/facebook'
import Twitter from './svg/twitter'
import Github from './svg/github'

const Social = () => {
  const data = useStaticQuery(graphql`
    {
      prismicConfig {
        ...PrismicSocialFragment
      }
    }
  `)
  if (!data.prismicConfig.data.social) return null
  const socialData = data.prismicConfig.data.social
  const iconStyle = 'h-8 lg:h-10 w-8 lg:w-10 group-hover:opacity-80'
  return (
    <div className='flex space-x-3 md:order-2 justify-center sm:justify-start'>
      {socialData.map((social, index) => {
        const { social_network, social_network_url } = social
        if (social_network_url.url === 'null') return null
        return (
          <a
            className='transform hover:scale-110 rounded-full focus:outline-none focus:ring focus:ring-purple-500'
            href={social_network_url.url}
            target='_blank'
            rel='noopener noreferrer'
            key={`social-${index}`}
            aria-label={`Follow us on ${social.social_network}`}>
            {social_network.toLowerCase() === 'facebook' && <Facebook alt='Facebook' aria-hidden='true' className={`${iconStyle}`} />}
            {social_network.toLowerCase() === 'linkedin' && <LinkedIn alt='LinkedIn' aria-hidden='true' className={`${iconStyle}`} />}
            {social_network.toLowerCase() === 'twitter' && <Twitter alt='X:Twitter' aria-hidden='true' className={`${iconStyle}`} />}
            {social_network.toLowerCase() === 'github' && <Github alt='Github' aria-hidden='true' className={`${iconStyle}`} />}
          </a>
        )
      })}
    </div>
  )
}

export default Social
